import { useEffect, useState } from 'react';
import { dataFieldsImg, countryImg, industryImg, exchangesImg } from '../../images/ImageResolver';
import { textWithIcon, fetchData } from './Helpers';

function Indicators({ toggle = true }) {
  const [loading, setLoading] = useState(false);
  const [dfOverlay, setDfOverlay] = useState(false);
  const [countryOverlay, setCountryOverlay] = useState(false);
  const [industryOverlay, setIndustryOverlay] = useState(false);
  const [exchangesOverlay, setExchangesOverlay] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const [dfData, setDfData] = useState([]);
  const [countryData, setCountryData] = useState([]);
  const [industryData, setIndustryData] = useState([]);
  const [exchangesData, setExchangesData] = useState([]);

  function searchEvent(val) {    
    setSearchData(dfData.filter(item => item.eventName.toLowerCase().includes(val.toLowerCase())));
  }

  function searchCountry(val) {    
    setSearchData(countryData.filter(item => item.countryName.toLowerCase().includes(val.toLowerCase())));
  }

  function searchIndustry(val) {    
    setSearchData(industryData.filter(item => item.industryName.toLowerCase().includes(val.toLowerCase())));
  }

  function searchExchanges(val) {
    setSearchData(exchangesData.filter(item => item.exchangeName.toLowerCase().includes(val.toLowerCase())));
  }

  function datafieldsClick() {
    setSearchData([]);
    setLoading(true);
    setDfOverlay(true);
    fetchData("Event_Data_Fields").then(res => {
      setDfData(res);
      setLoading(false);
    });
  }

  function countryClick() {
    setSearchData([]);
    setLoading(true);
    setCountryOverlay(true);
    fetchData("Event_Country").then(res => {
      setCountryData(res);
      setLoading(false);
    });
  }

  function industryClick() {
    setSearchData([]);
    setLoading(true);
    setIndustryOverlay(true);
    fetchData("Event_Industry").then(res => {
      setIndustryData(res);
      setLoading(false);
    });
  }

  function exchangesClick() {
    setSearchData([]);
    setLoading(true);
    setExchangesOverlay(true);
    fetchData("Event_Exchanges").then(res => {
      setExchangesData(res);
      setLoading(false);
    });
  }

  function toggleDataFields(title) {
    const dfgrid = document.getElementById('dataFieldsGrid');
    if(title === "Headlines"){
      dfgrid.api.hideColumn(2, true);
      dfgrid.api.hideColumn(3, false);
    }else{
      dfgrid.api.hideColumn(2, false);
      dfgrid.api.hideColumn(3, true);
    }
  }

  useEffect(() => {
    const grid = document.getElementById('dataFieldsGrid');
    const columns = [
      { name: 'Event Type', field: 'eventName', width: 3, scalable: true },
      { name: 'Description', field: 'fieldDescription', width: 5, scalable: true, binding: cellWithMultipleLines },
      { name: 'Status', field: 'caHeadline', width: 2, scalable: true, binding: textWithIcon},
      { name: 'Status', field: 'caDetail', width: 2, scalable: true, binding: textWithIcon, visible: false}
    ]

    function cellWithMultipleLines(e) {
      let cell = e.cell;
      let content = cell.getContent();
      if (!content) {
        content = document.createElement("div");
        // content.style.textAlign = "center";
        content.style.whiteSpace = "pre-line";
        let firstLine = document.createElement("span");
        firstLine.style.backgroundColor = "transparent";
        firstLine.style.border = "none";
        firstLine.style.margin = "0px";
        firstLine.style.padding = "0px";
        firstLine.textContent = e.data;
        content._firstLine = firstLine;
        content.appendChild(firstLine);
      }
      cell.setContent(content);
    }

    grid.config = {
      rowHeight: 60,
      headerRowHeight: 50,
      columns: columns,
      dataModel: {
        data: searchData.length > 0 ? searchData : dfData
      },
      sorting: {
        sortableColumns: false,
        initialSort: {
            colIndex: 0, // Column index
            sortOrder: "a"
        }
      }
    };
  }, [dfData, searchData]);

  useEffect(() => {
    const grid = document.getElementById('countryGrid');
    const columns = [
      { name: 'Name', field: 'countryName', width: 5, scalable: true, binding: cellWithMultipleLines },
      { name: 'Code', field: 'countryCode', width: 5, scalable: true }
    ]

    function getCountryCode(data){
      const dataArr = data.map(row => ({
        countryName: row.countryName+","+row.countryCode,
        countryCode: row.countryCode
      }));
      return dataArr;
    }

    function cellWithMultipleLines(e) {
      let cell = e.cell;
      let data = e.data.split(",");
      let content = cell.getContent();
      if (!content) {
        content = document.createElement("div");
        content.className = 'flag-cell';

        let firstLine = document.createElement("span");
        firstLine.className = 'flag-cell__text';
        let flag = document.createElement("ef-flag");
        flag.className = 'flag-cell__flag';
        flag.style.fontSize = "24px";
        flag.style.marginRight = "10px";
        flag.style.verticalAlign = "middle";
        flag.style.borderRadius = "4px";
        content._flag = flag;
        content._firstLine = firstLine;
        content.appendChild(flag);
        content.appendChild(firstLine);
        cell.setContent(content);
      }

      const flagEl = content.querySelector('.flag-cell__flag');
      flagEl.flag = data[1].toLowerCase();
      const textEl = content.querySelector('.flag-cell__text');
      textEl.textContent = data[0];
    }

    grid.config = {
      rowHeight: 50,
      headerRowHeight: 50,
      columns: columns,
      dataModel: {
        data: getCountryCode(searchData.length > 0 ? searchData : countryData)
      },
      sorting: {
        sortableColumns: false,
        initialSort: {
            colIndex: 0, // Column index
            sortOrder: "a"
        }
      }
    };
  }, [countryData, searchData]);

  useEffect(() => {
    const grid = document.getElementById('industryGrid');
    const columns = [
      { name: 'Name', field: 'industryName', width: 5, scalable: true,},
      { name: 'Code', field: 'industryCode', width: 5, scalable: true }
    ]

    grid.config = {
      rowHeight: 50,
      headerRowHeight: 50,
      columns: columns,
      dataModel: {
        data: searchData.length > 0 ? searchData : industryData
      },
      sorting: {
        sortableColumns: false,
        initialSort: {
            colIndex: 0, // Column index
            sortOrder: "a"
        }
      }
    };
  }, [industryData, searchData]);

  useEffect(() => {
    const grid = document.getElementById('exchangesGrid');
    const columns = [
      { name: 'Name', field: 'exchangeName', width: 5, scalable: true,},
      { name: 'Code', field: 'exchangeCode', width: 5, scalable: true }
    ]

    grid.config = {
      rowHeight: 50,
      headerRowHeight: 50,
      columns: columns,
      dataModel: {
        data: searchData.length > 0 ? searchData : exchangesData
      },
      sorting: {
        sortableColumns: false,
        initialSort: {
            colIndex: 0, // Column index
            sortOrder: "a"
        }
      }
    };
  }, [exchangesData, searchData]);

  return (
    <div>
      <ef-loader class="loader" hidden={!loading}></ef-loader>
      <ef-overlay className="indicator-overlay" with-backdrop with-shadow opened={dfOverlay}>
        <ef-layout flex className="overlay-header">
          <ef-layout><h5>Data Fields</h5></ef-layout>
          <ef-layout className="right"><ef-button icon="cross" transparent onClick={() => setDfOverlay(false)}></ef-button></ef-layout>
        </ef-layout>
        <ef-layout>
          <ef-button-bar className="data-fields-btn-bar" managed>
            <ef-button toggles active onClick={() => toggleDataFields("Headlines")}>Headlines Data Fields</ef-button>
            <ef-button toggles onClick={() => toggleDataFields("Details")}>Details Data Fields</ef-button>
          </ef-button-bar>
        </ef-layout>
        <ef-layout>
          <input
            className='indicators-search-field'
            type="text"
            placeholder="Type to search..."
            onChange={(e) => searchEvent(e.target.value)}
          />
        </ef-layout>
        <ef-layout>
          <efx-grid id="dataFieldsGrid" className="datafields-grid"></efx-grid>
        </ef-layout>
      </ef-overlay>
      <ef-overlay className="indicator-overlay" with-backdrop with-shadow opened={countryOverlay}>
        <ef-layout flex className="overlay-header">
          <ef-layout><h5>Country</h5></ef-layout>
          <ef-layout className="right"><ef-button icon="cross" transparent onClick={() => setCountryOverlay(false)}></ef-button></ef-layout>
        </ef-layout>
        <ef-layout>
          <input
            className='indicators-search-field'
            type="text"
            placeholder="Type to search..."
            onChange={(e) => searchCountry(e.target.value)}
          />
        </ef-layout>
        <ef-layout>
          <efx-grid id="countryGrid" className="datafields-grid"></efx-grid>
        </ef-layout>
      </ef-overlay>
      <ef-overlay className="indicator-overlay" with-backdrop with-shadow opened={industryOverlay}>
        <ef-layout flex className="overlay-header">
          <ef-layout><h5>Industry</h5></ef-layout>
          <ef-layout className="right"><ef-button icon="cross" transparent onClick={() => setIndustryOverlay(false)}></ef-button></ef-layout>
        </ef-layout>
        <ef-layout>
          <input
            className='indicators-search-field'
            type="text"
            placeholder="Type to search..."
            onChange={(e) => searchIndustry(e.target.value)}
          />
        </ef-layout>
        <ef-layout>
          <efx-grid id="industryGrid" className="datafields-grid"></efx-grid>
        </ef-layout>
      </ef-overlay>
      <ef-overlay className="indicator-overlay" with-backdrop with-shadow opened={exchangesOverlay}>
        <ef-layout flex className="overlay-header">
          <ef-layout><h5>Exchanges</h5></ef-layout>
          <ef-layout className="right"><ef-button icon="cross" transparent onClick={() => setExchangesOverlay(false)}></ef-button></ef-layout>
        </ef-layout>
        <ef-layout>
          <input
            className='indicators-search-field'
            type="text"
            placeholder="Type to search..."
            onChange={(e) => searchExchanges(e.target.value)}
          />
        </ef-layout>
        <ef-layout>
          <efx-grid id="exchangesGrid" className="datafields-grid"></efx-grid>
        </ef-layout>
      </ef-overlay>
      <ef-button-bar className="indicators-button-bar">
        <ef-button onClick={datafieldsClick}><img src={dataFieldsImg} alt="Data Fields" />Data Fields</ef-button>
        { toggle && <ef-button onClick={countryClick}><img src={countryImg} alt="Country" />Country</ef-button> }
        { toggle && <ef-button onClick={industryClick}><img src={industryImg} alt="Industry" />Industry</ef-button> }
        { toggle && <ef-button onClick={exchangesClick}><img src={exchangesImg} alt="Exchanges" />Exchanges</ef-button> }
      </ef-button-bar>
    </div>
  );

}

export default Indicators;